import React from 'react'
import ErrorPage from 'pages/DefaultErrorPage/DefaultErrorPage'

import { navigateToUrl } from 'single-spa'
import Lock from 'assets/lock.svg'

const NoAthorized = () => {
  return (
    <ErrorPage
      img={{
        src: Lock,
        alt: 'Cadeado',
      }}
      action="Acesso restrito"
      body="Me desculpe! Apenas usuários com permissão podem acessar essa página."
      button={{
        text: 'Ir para página inicial',
        onClick: () => navigateToUrl('/'),
      }}
    />
  )
}

export default NoAthorized
